import memoize from "memoize-one";
import { IDisplayPreferenceState } from "reducers/collection-item-display-preference";
import { IStore } from "reducers";
import { ARTIFICAL_ALLOCATION_DIMENSIONS_NODE } from "helpers/product-collection";

const getCollectionDisplayPreferenceRaw = memoize((itemDisplayPreferences: IDisplayPreferenceState) => {
    return {
        ...itemDisplayPreferences,
        currentView: itemDisplayPreferences.currentView?.filter(
            (m) => m.get("field_name") !== ARTIFICAL_ALLOCATION_DIMENSIONS_NODE,
        ),
    };
});

export const getCollectionDisplayPreference = (state: IStore) => {
    return getCollectionDisplayPreferenceRaw(state.collectionItemDisplayPreference);
};
